import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarCheck } from "lucide-react";

/** Resolve the Jane booking destination per priority:
 *  service URL → practitioner URL → main clinic URL → Contact Admissions fallback.
 *  Global toggle OFF → always fallback. */
export function resolveBooking(booking, { serviceId, practitionerId } = {}) {
  const b = booking || {};
  if (!b.enabled) return { type: "fallback" };
  const url =
    (serviceId && (b.service_urls || {})[serviceId]) ||
    (practitionerId && (b.practitioner_urls || {})[practitionerId]) ||
    b.main_url ||
    "";
  return url ? { type: "jane", url } : { type: "fallback" };
}

export default function TherapyBookingButton({ booking, serviceId, practitionerId, className = "", testId = "therapy-book-btn", size = "md" }) {
  const b = booking || {};
  const dest = resolveBooking(b, { serviceId, practitionerId });
  const pad = size === "sm" ? "px-5 py-2.5 text-xs" : "px-6 py-3 text-sm";

  if (dest.type === "jane") {
    return (
      <a
        href={dest.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId}
        className={`inline-flex items-center justify-center gap-2 rounded-full font-bold text-white transition-opacity hover:opacity-90 ${pad} ${className}`}
        style={{ backgroundColor: "#00A6B2" }}
      >
        <CalendarCheck className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
        {b.button_label || "Book Appointment"}
      </a>
    );
  }
  return (
    <Link
      to={b.fallback_path || "/contact"}
      data-testid={`${testId}-fallback`}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-bold border-2 transition-colors hover:bg-[#00A6B2]/5 ${pad} ${className}`}
      style={{ borderColor: "#00A6B2", color: "#00A6B2" }}
    >
      {b.fallback_label || "Contact Admissions"}
      <ArrowUpRight className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
    </Link>
  );
}
